import { generatePath } from "react-router";
import { CONFIRMATION_PATH, confirmationParamNames, confirmationSearchParamNames } from "./consts.js";
import { hotelInfoRouteParamNames } from "@modules/hotel-info-path";

interface ConfirmationPathParams {
  tripKey: string;
  hotelId: number;
  requestReview?: boolean;
}

export const getConfirmationPath = ({ tripKey, hotelId, requestReview }: ConfirmationPathParams): string => {
  const path = generatePath(CONFIRMATION_PATH, {
    [confirmationParamNames.tripKey]: tripKey,
    [hotelInfoRouteParamNames.hotelId]: String(hotelId),
  });
  return `${path}${requestReview ? `?${confirmationSearchParamNames.requestReview}=true` : ""}`;
};
